import { render, staticRenderFns } from "./TablaBeneficios.vue?vue&type=template&id=058b2379&scoped=true&"
import script from "./TablaBeneficios.vue?vue&type=script&lang=js&"
export * from "./TablaBeneficios.vue?vue&type=script&lang=js&"
import style0 from "./TablaBeneficios.vue?vue&type=style&index=0&id=058b2379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b2379",
  null
  
)

export default component.exports